module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_MURS_BARDAGE_BOIS_HORIZONTAL.6389ee94.webp";